import HeadlinerVideosByRSS from './HeadlinerVideosByRSS';

export default HeadlinerVideosByRSS;
